import * as PIXI from 'pixi.js';
import { TweenMax, TimelineMax, Power0, Power1 } from 'gsap/TweenMax';
import PhyTouch from './phyTouch';

const w = window.innerWidth;
const h = window.innerHeight;

const min = (w < h) ? w : h;
const max = (w > h) ? w : h;
const scale = min / 750;

class LongImage {
  constructor(options) {
    this.lib = { PIXI, TweenMax, TimelineMax, PhyTouch }
    this.callbacks = {
      loadProgress: []
    }
    // 参数
    this.options = options;
    this.container = options.container || document.body; // 容器
    this.width = options.width || window.innerWidth; // 场景的宽度
    this.height = options.height || window.innerHeight; // 场景的高度
    this.resource = options.resource || { sprites: [] } // 要加载的资源
    this.spritesAnimations = this.options.spritesAnimations || {} // 经理动画集合
    this.textsAnimations = this.options.textsAnimations || {} // 文本动画
    this.autoLoad = typeof options.autoLoad === 'undefined' ? true : options.autoLoad // 是否自动加载
    this.sprites = {} // 精灵图的集合
    this.texts = {} // 文本的集合
    this.aniIntervals = [] // 动画定时器
    this.preVal = 0 //存储滑动的距离
    this.phyTouch = null
    this.isLocked = false // 锁住位置变化
    this.scale = Math.min(this.width, this.height) / 750

    // 创建场景
    this.app = new PIXI.Application({
      resolution: 1,
      transparent: true,
      antialias: true,
      width: this.width,
      height: this.height,
      backgroundColor: 0xc8cece
    })
    // 加入场景
    this.container.appendChild(this.app.view)
    // 开始加载
    if (this.autoLoad) this.load()
  }

  load() {
    PIXI.loader
      .add(this.resource.sprites)
      .on('progress', this.loadProgress.bind(this))
      .load(this.loadDone.bind(this))
  }

  loadProgress(loader) {
    this.trigger('loadProgress', loader.progress)
  }

  loadDone() {
    this.initBg()
    this.initTexts()
    this.initSprites()
    this.initTimeline()
    this.trigger('loadDone')

    this.app.stage.scale.set(this.scale, this.scale);
    if (this.width < this.height) {   // 根据横屏竖屏效果旋转舞台
      this.app.stage.rotation = Math.PI / 2;
      this.app.stage.x = this.width;
      this.initTouch(true,'y', 0);
    }else {
      this.initTouch(false,'x', 0);
    }

    this.selfTween();

    // console.log({origin: this.app.stage});
    const _this = this;
    window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", function() {
      const qrDom = document.querySelector('.fn-qr');
      if (window.orientation === 180 || window.orientation === 0) {
        // alert('竖屏状态！');
        _this.isLocked = true;
        setTimeout(() => {
          _this.width = window.innerWidth;
          _this.height = window.innerHeight;
          const resizeScale = _this.width / 750;
          _this.scrollWidth = _this.originWidth * resizeScale - _this.height;
          _this.app.renderer.resize(_this.width, _this.height);
          _this.app.stage.scale.set(resizeScale,resizeScale);
          _this.preVal = _this.preVal / _this.scale * resizeScale;
          _this.app.stage.rotation = Math.PI / 2;
          _this.app.stage.position.x = _this.width;
          _this.app.stage.position.y = 0;
          _this.scale = resizeScale;
          _this.phyTouch.destroy();
          _this.initTouch(true, 'y', _this.preVal);
          _this.app.stage.position.y = _this.preVal;
        }, 400);
        setTimeout(() => {
          _this.isLocked = false;
        }, 2000);
        qrDom.classList.remove('fn-qr-l');
        qrDom.classList.remove('fn-qr-l__fn');
        qrDom.classList.add('fn-qr-p');
      }
      if (window.orientation === 90 || window.orientation === -90 ){
          // alert('横屏状态！');
        _this.isLocked = true;
        setTimeout(() => {
          _this.width = window.innerWidth;
          _this.height = window.innerHeight;
          const resizeScale = _this.height / 750;
          _this.scrollWidth = _this.originWidth * resizeScale - _this.width;
          _this.app.renderer.resize(_this.width, _this.height);
          _this.app.stage.scale.set(resizeScale,resizeScale);
          _this.preVal = _this.preVal / _this.scale * resizeScale;
          _this.app.stage.rotation = 0;
          _this.app.stage.position.y = 0;
          _this.scale = resizeScale;
          _this.phyTouch.destroy();
          if (Math.abs(_this.scrollWidth) - Math.abs(_this.preVal) <= _this.width) {
            _this.preVal = -_this.scrollWidth;
          }
          _this.initTouch(false, 'x', _this.preVal);
          _this.app.stage.position.x = _this.preVal;
        }, 400);
        setTimeout(() => {
          _this.isLocked = false;
        }, 2000)
        qrDom.classList.remove('fn-qr-p');
        qrDom.classList.remove('fn-qr-p__fn');
        qrDom.classList.add('fn-qr-l');
      }
    }, false);
  }

  selfTween() {
    const tm1 = new TweenMax.from(this.sprites['s2-computer'], 1, {delay: 1.6, alpha: 0, ease: Power2.easeInOut});
    const tm2 = new TweenMax.from(this.sprites['s2-calendar'], 1, {delay: 0.4, x: -690, ease: Power2.easeInOut});
    const tm3 = new TweenMax.from(this.sprites['s2-coffee'], 1, {delay: 0.6, x: -600, ease: Power2.easeInOut});
    const tm4 = new TweenMax.from(this.sprites['s2-keyboard'], 1, {delay: 1, y: 820, ease: Power2.easeInOut});
    const tm5 = new TweenMax.from(this.sprites['s2-leaf'], 1, {delay: 0.6, x: 1800, ease: Power2.easeInOut});
    const tm6 = new TweenMax.from(this.sprites['s2-notes'], 1, {delay: 2, alpha: 0, ease: Power2.easeInOut});
    const tl = new TimelineMax({repeat: -1, repeatDelay: 0.8});
    const element = this.sprites['s2-arrows'];
    tl.from(element, 0.1, {alpha: 0, ease: Power1.easeIn}).to(element, 1, { x: "+=100", ease: Power2.easeOut }).to(element, 0.1, {alpha: 0, ease: Power1.easeOut});
    tl.delay(3.5).play();
    this.tl = tl;
    tm1.play();
    tm2.play();
    tm3.play();
    tm4.play();
    tm5.play();
    tm6.play();
  }

  // 事件处理
  on(name, callback) {
    this.callbacks[name] = this.callbacks[name] || [];
    this.callbacks[name].push(callback)
  }

  off(name, callback) {
    const callbacks = this.callbacks[name];
    if (callbacks && callbacks instanceof Array) {
      const idx = callbacks.indexOf(callback)
      if (idx !== -1) callbacks.splice(idx, 1)
    }
  }

  trigger(name, params) {
    const callbacks = this.callbacks[name];
    if (callbacks && callbacks instanceof Array) {
      callbacks.forEach((cb) => {
        cb(params)
      })
    }
  }

  // 创建背景
  initBg() {
    // 创建 container 存放所有的背景图
    const bgSprites = this.options.bgSprites;
    this.bg = new PIXI.Container();
    let totalWidth = 0;
    for (let i = 0; i < bgSprites.length; i++) {
      const name = bgSprites[i].name;
      const bg = new PIXI.Sprite(PIXI.loader.resources[name].texture);
      bg.position.x = totalWidth;
      totalWidth += bg.width;
      this.bg.addChild(bg);
    }
    this.app.stage.addChild(this.bg);
    this.originWidth = this.app.stage.width;
    this.scrollWidth = this.app.stage.width * scale - max;
    this.app.stage.interactive = true;
    this.app.stage.on('touchstart', () => {
      this.tl.seek(0).pause();
    })
  }

  // 初始化文字
  initTexts() {
    if (typeof this.options.texts === 'object') {
      Object.keys(this.options.texts).forEach((key) => {
        // 创建
        const option = this.options.texts[key];
        const text = new PIXI.text(option.text, option.options)
        // 设置属性
        this.setAnchor(text, option.anchor)
        this.setPosition(text, option.position)
        // 加入场景
        this.app.stage.addChild(text)
        this.texts[key] = text
      })
    }
  }

  // 初始化精灵
  initSprites() {
    const sprites = {};
    for (let i = 0; i < this.options.sprites.length; i++) {
      const obj = this.options.sprites[i];
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          sprites[key] = new PIXI.Sprite(PIXI.loader.resources[key].texture);
          this.initSprite(sprites[key],obj[key]);
        }
      }
    }
    this.sprites = sprites;
  }

  initSprite(sprite, prop) {
    for (const key in prop) {
      if (prop.hasOwnProperty(key)) {
        sprite[key] = prop[key]
      }
    }
    this.bg.addChild(sprite)
  }

  // 设置 timeline
  initTimeline() {
    this.timeline = new TimelineMax({
      paused: true
    })
    console.log('timeline');

    // 设置精灵动画
    Object.keys(this.spritesAnimations).forEach((key) => {
      this.setAnimation(this.sprites[key], this.spritesAnimations[key])
    })

    // 设置文本动画
    Object.keys(this.textsAnimations).forEach((key) => {
      this.setAnimation(this.texts[key], this.textsAnimations[key])
    })
  }

  // 动画对象
  setAnimation(obj, animations) {
    if (obj && animations && animations instanceof Array) {
      animations.forEach(({ from, to, frames, infinite, frameRate, delay = 0, duration = 1 }) => {
        if (frames) {
          if (infinite) {
            obj.frames = frames;
            obj.currentFrame = 0;
            this.aniIntervals.push(setInterval(() => {
              obj.currentFrame += 1;
              if (obj.currentFrame >= obj.frames.length) {
                obj.currentFrame = 0;
              }
              const frame = obj.frames[obj.currentFrame];
              obj.texture = PIXI.loader.resources[frame].texture;
            }, duration * 1000 / frameRate))
          } else {
            this.on('progress', (progress) => {
              const frameProgress = (progress - delay) / duration;
              let index = Math.floor(frameProgress * frames.length);
              if (index < frames.length && index >= 0) {
                const frame = frames[index]
                obj.texture = PIXI.loader.resources[frame].texture
              }
            })
          }
        } else if (from || to) {
          let action;
          if (from && to) {
            action = TweenMax.fromTo(obj, duration, from, to)
          } else if (to) {
            action = TweenMax.to(obj, duration, to)
          } else if (from) {
            action = TweenMax.from(obj, duration, from)
          }
          const timeline = new TimelineMax({delay})
          timeline.add(action, 0)
          timeline.play()
          if (!(to && to.repeat === -1)) {
            this.timeline.add(timeline, 0)
          }
        }
      })
    }
  }

  // 滑动
  initTouch(vertical, val, value = 0) {
    let ver = vertical;
    let storeVal = val;
    const _this = this;
    this.phyTouch = new PhyTouch(Object.assign({
      touch: 'body'
    }, this.options.touchOptions, {
        vertical: vertical,
        min: -this.scrollWidth,
        max: 0,
        maxSpeed: 1,
        value,
        bindSelf: true,
        change: (value) => {
          if (!value && value !== 0) {
            _this.phyTouch.destroy();
            _this.phyTouch = _this.initTouch(ver, storeVal, _this.preVal);
          } else {
            if (!_this.isLocked) {
              let afterVal;
              if (value < -_this.scrollWidth / 2) {
                afterVal = value < -_this.scrollWidth ? -_this.scrollWidth : value;
              } else {
                afterVal = value > 0 ? 0 : value;
              }
              _this.app.stage.position[val] = afterVal
              console.log('after value: ', afterVal);
            }
            _this.preVal = value;
            _this.progress = -value / _this.scrollWidth;
            _this.progress = _this.progress <= 0 ? 0 : _this.progress;
            _this.progress = _this.progress >= 1 ? 1 : _this.progress;
            // 控制进度
            _this.timeline.seek(_this.progress);
            // 触发事件
            _this.trigger('progress', {progress: _this.progress, val: value, length: _this.scrollWidth});
            const qrDom = document.querySelector('.fn-qr');
            if (_this.width > _this.height) {
              if (_this.progress >= 0.98) {
                qrDom.classList.add('fn-qr-l__fn');
              } else {
                qrDom.classList.remove('fn-qr-l__fn')
              }
            } else {
              if (_this.progress >= 0.98) {
                qrDom.classList.add('fn-qr-p__fn');
              } else {
                qrDom.classList.remove('fn-qr-p__fn')
              }
            }
          }
        }
      }
    ))
  }
}

export default LongImage
